<h1 mat-dialog-title>No se puede eliminar el rol</h1>
<mat-dialog-content class="mat-typography">
  <h2>Pasos para eliminar rol:</h2>
  <div *ngIf="data.users.data.length > 0">
    <h3>{{ data.users.title }}</h3>
    <p>Debe de asignar otro rol a los usuarios</p>
    <p *ngFor="let user of data.users.data">-{{ user }}</p>
  </div>

  <div *ngIf="data.caseTypes.data.length > 0">
    <h3>{{ data.caseTypes.title }}</h3>
    <p>Debe de asignar otro rol a los tipos de casos gestionados</p>
    <p *ngFor="let caseType of data.caseTypes.data">-{{ caseType }}</p>
  </div>

  <div *ngIf="data.rolesInCases.data.length > 0">
    <h3>{{ data.rolesInCases.title }}</h3>
    <p>Debe de asignar otro rol a las aprobaciones de los tipos de casos</p>
    <p *ngFor="let rolesInCase of data.rolesInCases.data">-{{ rolesInCase }}</p>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button class="primary-btn rounded" mat-button mat-dialog-close>
    Entendido
  </button>
</mat-dialog-actions>
